import { t } from "i18next";
import BaseModal from "../../shared/BaseModal";
import Button from "../../shared/button/Button";
import Input from "../../shared/input/Input";
import Typography from "../../shared/typography/Typography";

import { Content, Row} from "./style";

interface IProps {
  value: string;
  setValue: React.Dispatch<string>;
  title: string;
  setShowModal: React.Dispatch<boolean>;
  showModal: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  inputRequired?: boolean;
  label: string;
}

export const InputModal = ({ 
  setShowModal, 
  showModal, 
  setValue, 
  title, 
  value,
  onConfirm, 
  onCancel, 
  inputRequired=false,
  label
}: IProps) => {
  return (
    <BaseModal 
      title={title} 
      toggleModal={showModal} 
      setToggleModal={setShowModal} 
      onCancel={onCancel}
      footer={
          <Row>
            <Button 
              typographyType="headingXXS"
              variant="outlined" 
              colorBackground="label" 
              colorFont="label" 
              colorHover="label" 
              size='small'
              enable 
              rounded
              fullWidth
              onClick={onCancel}
              > 
                {t("cancel")} 
              </Button>
            <Button   
              typographyType="headingXXS"
              colorBackground="primary" 
              colorFont="white" 
              enable={value.trim()!== "" || !inputRequired}
              tooltip={value.trim()!== "" || !inputRequired ? "" : t("fillAllFields")!}
              size='small'
              fullWidth
              rounded 
              onClick={onConfirm}
            > 
              {t("confirm")} 
            </Button>
          </Row>
        } 
    >
      <Content>
        <Typography type="paragraphS" color="title">{label}</Typography>
        <Input style={{textAlign: "center"}} placeholder="Título" onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
          setValue(e.target.value)} value={value} />
      </Content>
    </BaseModal>
  );
}